import React, { memo, useEffect, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import KeyboardArrowDownIcon from 'components/icons/ArrowDown.svg'
import { useSelector } from 'react-redux'
import pickBy from 'lodash/pickBy'
import isEmpty from 'lodash/isEmpty'
import sx from './styles'

const allowedKeys = ['maker', 'model', 'year', 'transmission']
const sortTitleMap = {
  'price:asc': 'SEARCH_SORT_BY_PRICE_ASC',
  'price:desc': 'SEARCH_SORT_BY_PRICE_DESC',
  'discountAmount:desc': 'VEHICLE_STATUS_WITH_DISCOUNT_FILTER',
  'year:desc': 'SEARCH_MOBILE_SORT_BY_YEAR_DESC',
  'mileage:asc': 'SEARCH_MOBILE_SORT_BY_MILEAGE_ASC',
}

const ButtonsModalsFilters = ({
  onClickOrderModal,
  onClickModal,
}) => {
  const { formatMessage: f } = useIntl()
  const filters = useSelector((s) => s.search.filters)

  const filterSelectedlLength = Object.keys(pickBy(filters))
    ?.filter((k) => allowedKeys?.includes(k))
    ?.length

  useEffect(() => {
    const tempFilters = { ...filters }
    delete tempFilters?.sort
  }, [filters])

  const getTextAdvanceFiltros = (filtersLength) => {
    return `${f({ id: filtersLength ? 'SEARCH_ALL_FILTER_TITLE_VARIANT' : 'SEARCH_ALL_FILTER_TITLE' })}${filtersLength > 0 ? `(${filtersLength})` : ''}`
  }

  const buttonSort = (
    <Button
      pl={0}
      variant="text"
      onClick={onClickOrderModal}
      sx={sx.button}
    >
      {filters?.sort ? (
        <Typography
          component="span"
          sx={sx.truncateText}
        >
          <FormattedMessage id={sortTitleMap[filters?.sort]} />
        </Typography>
      ) : (
        <FormattedMessage id="SEARCH_SORT_TITLE" />
      )}

      <KeyboardArrowDownIcon />
    </Button>
  )

  const advanceFiltersButton = (
    <Button
      variant="text"
      onClick={onClickModal}
      sx={sx.button}
    >
      {getTextAdvanceFiltros(filterSelectedlLength)}
      <KeyboardArrowDownIcon />
    </Button>
  )

  return (
    <>
      <Box
        mb={1}
        sx={sx.filtersBtnContainer}
      >
        <Box sx={{ ...sx.buttonContainer, ...sx.button1 }}>
          {buttonSort}
        </Box>
        <Box sx={{ ...sx.buttonContainer, ...sx.button2 }}>
          {advanceFiltersButton}
        </Box>

      </Box>
    </>
  )
}

export default memo(ButtonsModalsFilters)
